import { defer, LoaderFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isDefined, isNotDefined, isTokenExpired, retrieveToken } from '@hsp/utilities';

import { createListPerformanceQuery } from '@p/a/r/lp/hooks/queries/fetch-list-performance.hook';
import { listPerformanceLoaderDefaults } from '@p/a/r/lp/utilities/loader-defaults.util';

import { getSortString } from '@u/sorts';

export const listPerformanceLoader = (queryClient: QueryClient) => {
  return ({ params: { startDate, endDate }, request }: LoaderFunctionArgs) => {
    const client = new URL(request.url).searchParams.get('clientAcronym') ?? undefined;
    const listOwner = new URL(request.url).searchParams.get('listOwner') ?? undefined;
    const managerCode = new URL(request.url).searchParams.get('managerCode') ?? undefined;
    const filter = new URL(request.url).searchParams.get('filter') ?? undefined;
    const listCode = new URL(request.url).searchParams.get('listCode') ?? undefined;
    const page = new URL(request.url).searchParams.get('page') ?? undefined;
    const pageSize = new URL(request.url).searchParams.get('pageSize') ?? undefined;
    const segment = new URL(request.url).searchParams.get('segment') ?? undefined;
    const sort = new URL(request.url).searchParams.get('sort') ?? undefined;
    const id = new URL(request.url).searchParams.get('id') ?? undefined;

    ({ endDate, startDate } = listPerformanceLoaderDefaults(startDate, endDate));

    const query = createListPerformanceQuery({
      clientAcronym: isDefined(client) ? [client] : undefined,
      endDate,
      filter,
      id,
      listCode,
      listOwner,
      managerCode,
      page: isDefined(page) ? parseInt(page) : 1,
      pageSize: isDefined(pageSize) ? parseInt(pageSize) : 10,
      segment,
      sort: getSortString(sort) ?? getSortString([{ direction: 'desc', field: 'mailDate' }]),
      startDate,
    });
    const { queryKey } = query;

    if (isNotDefined(queryKey)) {
      throw new Error('QueryKey not provided');
    }
    const token = retrieveToken();

    if (isNotDefined(token) || isTokenExpired(token)) {
      return defer({ listPerformancePage: undefined });
    }

    const listPerformancePage = queryClient.ensureQueryData(query);

    return defer({ listPerformancePage });
  };
};
